import React from "react"

const SheepHeadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div
    style={{
      height: "30px",
      width: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "var(--notification-yellow)",
      borderRadius: "5px",
    }}
  >
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 30 30"
    >
      <g
        id="sheep_1_"
        data-name="sheep (1)"
        transform="translate(-87.219 -63.75)"
      >
        <path
          d="M43 356h16a7 7 0 0 1 7 7v16a7 7 0 0 1-7 7H43a7 7 0 0 1-7-7v-16a7 7 0 0 1 7-7z"
          fill="var(--notification-yellow)"
          fillRule="evenodd"
          data-name="box icon #1"
        />
        <path
          id="Path_1800"
          data-name="Path 1800"
          d="M114.079,74.138c.558-.554,3.658-2.2,3.357-2.925s-3.922-.314-4.708-.314h-.9a3.986,3.986,0,0,0,.029-.664,4.06,4.06,0,0,0-1.174-2.677,4.13,4.13,0,0,0-2.671-1.218,4.034,4.034,0,0,0-.727.022.965.965,0,0,1-.866-.394,4.889,4.889,0,0,0-7.838-.007.956.956,0,0,1-.866.394,4.074,4.074,0,0,0-3.4,1.2,4.09,4.09,0,0,0-1.174,2.677,3.986,3.986,0,0,0,.029.664h-.9c-.785,0-4.491-.4-4.792.321s2.891,2.37,3.441,2.917a3.893,3.893,0,0,0,.983.715,4.061,4.061,0,0,0,.382,6.1.877.877,0,0,1,.294.985,4.673,4.673,0,0,0-.272,1.59A4.776,4.776,0,0,0,97.09,88.28H97.1a.889.889,0,0,1,.837.562,4.889,4.889,0,0,0,9.144,0,.889.889,0,0,1,.837-.562h.015a4.776,4.776,0,0,0,4.785-4.755,4.858,4.858,0,0,0-.272-1.59.877.877,0,0,1,.294-.985,4.061,4.061,0,0,0,.382-6.1,4.087,4.087,0,0,0,.954-.707Zm-1.35-2.421c.536,0,3.706-.458,3.838-.137s-2.7,1.6-3.075,1.975a3.214,3.214,0,0,1-3.273.766c-.059-.175-.125-.35-.191-.518a4.305,4.305,0,0,0,.69-.576,4.049,4.049,0,0,0,.925-1.51h1.086ZM95.7,74.189a4.185,4.185,0,0,0,1.534.292,4.1,4.1,0,0,0,2.627-.948.965.965,0,0,1,.939-.153,4.885,4.885,0,0,0,3.405,0,.965.965,0,0,1,.939.153,4.1,4.1,0,0,0,2.627.948,4.156,4.156,0,0,0,1.534-.292,7.031,7.031,0,0,1,.5,2.611,7.218,7.218,0,0,1-2.363,5.339,3.134,3.134,0,0,0-.778,1.109c-.859,2.049-2.253,3.092-4.154,3.092s-3.3-1.043-4.154-3.092a3.071,3.071,0,0,0-.778-1.109A7.242,7.242,0,0,1,95.219,76.8,6.736,6.736,0,0,1,95.7,74.189Zm-1.739-3.924a3.28,3.28,0,0,1,3.075-3.107,3.083,3.083,0,0,1,.58.015,1.792,1.792,0,0,0,1.629-.722,4.052,4.052,0,0,1,6.5,0,1.778,1.778,0,0,0,1.629.722,3.083,3.083,0,0,1,.58-.015,3.3,3.3,0,0,1,3.075,3.107,3.262,3.262,0,0,1-3.273,3.392,3.328,3.328,0,0,1-2.1-.751,1.783,1.783,0,0,0-1.13-.4,1.842,1.842,0,0,0-.624.109,4.009,4.009,0,0,1-1.409.248,4.181,4.181,0,0,1-1.409-.248,1.792,1.792,0,0,0-1.754.292,3.3,3.3,0,0,1-4.462-.248A3.217,3.217,0,0,1,93.964,70.265ZM89.118,71.58c.132-.321,2.615.137,3.143.137h1.086a4.049,4.049,0,0,0,.925,1.51,4.307,4.307,0,0,0,.69.576c-.073.168-.132.343-.191.518a3.214,3.214,0,0,1-3.273-.766c-.374-.372-2.512-1.654-2.38-1.975Zm24.36,6.161a3.213,3.213,0,0,1-1.27,2.567,1.684,1.684,0,0,0-.558,1.9,3.8,3.8,0,0,1,.228,1.313,3.95,3.95,0,0,1-3.956,3.931h-.015a1.719,1.719,0,0,0-1.615,1.1,4.054,4.054,0,0,1-7.588,0,1.722,1.722,0,0,0-1.615-1.1h-.015a3.95,3.95,0,0,1-3.956-3.931,3.8,3.8,0,0,1,.228-1.313,1.684,1.684,0,0,0-.558-1.9,3.233,3.233,0,0,1-.022-5.12,4.156,4.156,0,0,0,1,.124,3.938,3.938,0,0,0,.771-.073,7.947,7.947,0,0,0-.154,1.568,8.063,8.063,0,0,0,2.635,5.944,2.258,2.258,0,0,1,.572.824c.983,2.356,2.679,3.6,4.917,3.6s3.934-1.247,4.917-3.6a2.258,2.258,0,0,1,.572-.824,8.063,8.063,0,0,0,2.635-5.944,7.948,7.948,0,0,0-.154-1.568,3.938,3.938,0,0,0,.771.073,4.2,4.2,0,0,0,1-.124A3.269,3.269,0,0,1,113.478,77.741Z"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.5"
        />
        <path
          id="Path_1801"
          data-name="Path 1801"
          d="M185.884,233.714a.819.819,0,0,1-.739.475.41.41,0,1,0,0,.819,1.621,1.621,0,0,0,1.229-.556,1.647,1.647,0,0,0,1.229.556.41.41,0,0,0,0-.819.807.807,0,0,1-.739-.475,2,2,0,0,0,1.4-1.295,1.093,1.093,0,0,0-.622-1.273,3.837,3.837,0,0,0-2.516,0,1.1,1.1,0,0,0-.622,1.273A1.949,1.949,0,0,0,185.884,233.714Zm-.38-1.843a3.295,3.295,0,0,1,1.741,0c.263.139.227.278.212.351a1.162,1.162,0,0,1-2.165,0C185.269,232.149,185.24,232.01,185.5,231.871Z"
          transform="translate(-83.924 -150.605)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  </div>
)

export default SheepHeadIcon
